export function notify(message: Message, subscribers: Subscriber[]): void {
  subscribers.forEach((subscriber: Subscriber) => {
    subscriber(message);
  });
}
